function MapZoom(props) {
	return (
		<div className="mapZoom">
			<button onClick={() => props.handler('plus')}>
				<img src="img/zoomPlus.png" alt="확대" />
			</button>
			<button onClick={() => props.handler('minus')}>
				<img src="img/zoomMin.png" alt="축소" />
			</button>
		</div>
	);
}

export default MapZoom;
